import * as React from 'react'
import { useIntl } from 'react-intl'
import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'
import DialogTitle from '@mui/material/DialogTitle'
import { Box, IconButton } from '@mui/material'
import CopyIcon from '../../assets/icons/Documents/Copy-Document-Filled.svg'
import { ui } from '../../utils/uiTokens'

interface Props {
    confirmAction: () => void
}

const ConfirmDuplicate: React.FC<Props> = ({ confirmAction }) => {
    const { formatMessage } = useIntl()
    const [open, setOpen] = React.useState(false)

    return (
        <Box sx={{ m: 'auto' }}>
            <IconButton
                onClick={() => setOpen(true)}
                sx={{
                    background: ui.pinkSoft,
                    '&:hover': { background: ui.border },
                }}
            >
                <img
                    src={CopyIcon}
                    alt="duplicate"
                />
            </IconButton>

            <Dialog
                maxWidth="sm"
                fullWidth
                open={open}
                onClose={() => setOpen(false)}
            >
                <DialogTitle>Подтверждение</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        Вы уверены что хотите дублировать этот курс?
                    </DialogContentText>
                </DialogContent>
                <DialogActions sx={{ m: 2 }}>
                    <Button onClick={() => setOpen(false)}>
                        {formatMessage({ id: 'cancel' })}
                    </Button>
                    <Button
                        variant="contained"
                        onClick={() => {
                            confirmAction()
                            setOpen(false)
                        }}
                    >
                        Дублировать
                    </Button>
                </DialogActions>
            </Dialog>
        </Box>
    )
}

export default ConfirmDuplicate
